// import { Alert } from "bootstrap";
import React, { useState, useRef, useEffect, useContext } from "react";
import { useTable, usePagination } from "react-table";
import CompanyApi from "../../../API/APIServices/Company";
import { useNavigate, useParams } from "react-router-dom";
import Status from "../../../API/APIServices/Status";
import Agent from "../../../API/APIServices/Agent";
import AgentApi from "../../../API/APIServices/Agent";
import AddVoucher from "../../../API/APIServices/AddVoucher";
import MyContext from "../../MyContext";
import Order from "../../../API/APIServices/Order";
import TransactionTypeSettingAPI from "../../../API/APIServices/TransactionTypeSetting";
import Loader from "../../Props/Loader";
import Account from "../../../API/APIServices/Account";
import { debounce } from "lodash";

import getCaseInSensitiveFieldValueFromObject from "../../../Utils/GetCaseInsensitiveFieldValueFromObject";
import getOriginalObjFieldBasedOnAnyCase from "../../../Utils/GetOriginalObjFieldBasedOnAnyCase";


const MasterReportDataTable = ({
  handleNameChange,
  setPageNumber,
  PageNumber,
  pagecount,
  columns,
  data,
  filterData,
  totalValue,
  searchAnyText,
  debouncedFunction,
  searchByDate,
  searchByColumn,
  handleKeyDownUniversal,
  customStartDate,
  customEndDate,
  handleCustomDateChange,
  firmNameSelect,
  transactionType,
  billSeries,
  useDoubleClick,
  reportAttachTo,
  navigateTo,
  handleNavigation,
  setDateFilterCustom,
  DateFilterCustom,

  totalRecords,
  addOrders,
  showNav,
  DropdownData = [],
  currentPageId,
  changetablevalue,
  nameSearch,
  changeDoubleClickFilter,
  setReportAttachTo,
  handleNavigation1,
  templateData,
  setDisableDoubleclick,
  disableDoubleClick,
  setOpenMessageModal,
  setSelectedStatusId1,
  setTransactonId,
  setMobileNo,
  setEmail,
  showSetting,
  templateSettingDTOId,
  handleAlphabetSelect,
  dbColumnAndReportColumnNameMap,
  filtercondition,
  selectedOptions2 = [],
  setSelectedOptions2,
  rowWiseEdit1,
  rowWiseDelete1,
  rowWiseWhatsapp1,
  rowWisePrint1,
  queryData,
  combinedTotalValue,
  ef1,
  ef2,
  reportType,
  fetchData,
  commonFilter,
  setCommonFilter,
  dateRangeToShow,
  setDateRangeToShow,
  handleResetQueryDate,
  setCustomStartDate,
  setCustomEndDate
}) => {
  useEffect(() => {
    console.log("selectedOptions2", selectedOptions2);
  }, [selectedOptions2]);
  const [suggeitem, setsuggetion] = useState([]);
  const { UserDetails, decimalPlaces } = useContext(MyContext);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  // useEffect(() => {
  //   console.log("pagecount", pagecount);
  //   console.log("totalRecords", totalRecords);
  // }, [pagecount, totalRecords]);
  const { id } = useParams();

    function formatDate(dateString) {
    const date = new Date(dateString);

    // Get the day, month, year, hours, minutes, and AM/PM
    const day = String(date.getDate()).padStart(2, "0"); // Pad single digit day with leading zero
    const month = date.toLocaleString("default", { month: "short" }); // Get abbreviated month name (e.g., "Jan")
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Pad single digit minutes with leading zero
    let ampm = "AM";

    if (hours >= 12) {
      ampm = "PM";
      if (hours > 12) {
        hours -= 12; // Convert 24-hour to 12-hour format
      }
    } else if (hours === 0) {
      hours = 12; // Handle midnight
    }

    // Format as dd Jan yyyy hh:mm AM/PM
    // return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
    return `${day}\u00A0${month}-${year}`;
  }

  useEffect(() => {
    console.log("UserDetails", UserDetails);
  }, [UserDetails]);

  const filterDateDivRef = useRef(null);
  const [isDropdownOpen1, setisDropdownOpen1] = useState("");
  const [statusvalue, setstatusvalue] = useState([]);
  const [selectedstatus, setselectedstatus] = useState(null);
  const [disableaction, setdisableAction] = useState(false);
  const [disablecheckbox, setdisableAcheckbox] = useState(false);
  // const [disableDoubleClick, setDisableDoubleclick] = useState(false);
  const [StatusOption, setStatusOption] = useState([]);
  const [CustomDateFilter, setCutomDateFilter] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [showbox, setShowbox] = useState(false);
  const pageNumInputRef = useRef(null);
  const [TransactionTypeSetting, setTransactionTypeSetting] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [activeAlphabet, setActiveAlphabet] = useState(null);


  const showdatefilter = () => {
    setShowbox((prevShowbox) => !prevShowbox);
  };

  useEffect(() => {
    console.log("StatusOption", StatusOption);
  }, [StatusOption]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of 'rows', we'll use 'page'
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 15 }, // Set the initial page index and page size
    },
    usePagination // Add the usePagination plugin
  );

  console.log("totalValue", totalValue);

  // useEffect(() => {

  //   setPageSize(pagecount);
  // }, [pagecount]);
  useEffect(() => {
    if (selectedOptions2 && selectedOptions2.length > 1) {
      setPageSize(pagecount * selectedOptions2.length);
    } else {
      setPageSize(pagecount);
    }
  }, [pagecount, selectedOptions2]);

  useEffect(() => {
    // ;

    if (templateData) {
      if (
        !templateData.templateSettingDTO.rowWise_Delete &&
        !templateData.templateSettingDTO.rowWise_Edit &&
        !templateData.templateSettingDTO.rowWise_Print &&
        !templateData.templateSettingDTO.rowWise_Whatsapp &&
        !templateData.templateSettingDTO.rowWise_TransporterOrOther &&
        !templateData.templateSettingDTO.rowWise_ArrowForOtherPage &&
        parseInt(templateData.templateSettingDTO.reportAttachTo) != 4
      ) {
        setdisableAction(true);
      }
      if (templateData.templateSettingDTO.srch3) {
        setdisableAcheckbox(true);
      }
    }
  }, [templateData]);

  const fetchStatusMaster = async () => {
    try {
      // ;
      const status = await Status.GetStatus();
      console.log("Status", status);
      if (status?.length != 0) {
        setStatusOption(status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitForall = async (e, item) => {
    try {
      // ;
      console.log(`statusvalue`, statusvalue);

      const confirm = window.confirm(
        `Do you want to save all selected row status!`
      );
      if (!confirm) return;

      const storedArrayString = localStorage.getItem("loginAccountUserData");
      const loginUser = JSON.parse(storedArrayString);

      const promises = [];
      if (statusvalue.length != 0) {
        for (let i = 0; i < selectedData.length; i++) {
          const masterType = reportAttachTo;
          const Transid = selectedData[i].id;
          const statusId = statusvalue.find(
            (fitem) => fitem.id == Transid
          )?.statusid;

          if (masterType && Transid && statusId) {
            // Push the promise to an array
            const updateResult = await AddVoucher.UpdateVouchStatusByid(
              masterType,
              Transid,
              statusId
            ).then((res) => res.isSuccess && promises.push(Transid));

            console.log(updateResult);

            if (updateResult?.isSuccess) {
              // Prepare data for insertItemStatus

              const extractIdFromSaleUsedIn = (saleusedin) => {
                const match = saleusedin?.match(/\d+/); // Matches first number in the string
                return match ? parseInt(match[0], 10) : 0;
              };

              //const ord2IdValue = isSaleOrderToInvoice ? item.original.id : (item.original.ord2Id || 0);

              const saleusedin = getOriginalObjFieldBasedOnAnyCase("saleusedin", item.original);
              const saleusedinid = getOriginalObjFieldBasedOnAnyCase("saleusedinid", item.original);
              const masttype = getOriginalObjFieldBasedOnAnyCase("saleusedinid", item.masttype);

              var ord2IdValue = 0;
              if (saleusedin) {
                ord2IdValue =
                  masttype == 12 ? saleusedinid : 0;
              } else {
                ord2IdValue = 0;
              }

              const data = {
                ord1Id: selectedData[i].ord1Id || Transid, // adjust if needed
                ord2Id: ord2IdValue, // adjust if needed
                statusId: statusId,
                orderDateTime: new Date().toISOString(),
                createdBy: loginUser.userId,
                isActive: true,
              };

              // Call insertItemStatus API
              const insertResult = await Order.insertItemStatusInventory(data);

              // If both succeed, push to promises
              if (insertResult) {
                promises.push(Transid);
              }
            }
          }
        }
      } else {
        return alert(`Please update any status.`);
      }
      // if (results.isSuccess) {
      alert(`Status Update Successfully! ${promises.map((item) => item)}`);
      // }
    } catch (error) {
      console.log(error);
      alert(`Status Update Failed!`);
    }
  };

  const [selectedData, setselectedData] = useState([]);
  const handleinputchange = async (e, row) => {
    try {
      // ;
      console.log(e);
      console.log(row);
      const existing = selectedData.find((prev) => prev.id == row.id);
      if (!existing) {

        const rowOriginalId = getCaseInSensitiveFieldValueFromObject("Id", row.original);
        const rowOriginalStatusId = getCaseInSensitiveFieldValueFromObject("statusid", row.original);

        const data = {
          id: rowOriginalId,
          statusid: rowOriginalStatusId,
          masterType: reportAttachTo,
        };
        setselectedData((prev) => [...prev, data]);
      } else {

        const rowId = getCaseInSensitiveFieldValueFromObject("Id", row);

        const tempdata = selectedData.filter((prev) => prev.id != rowId);
        setselectedData(tempdata);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log(`selecteddata`, selectedData);
  }, [selectedData]);

  const fetchAgentMaster = async () => {
    try {
      // ;
      const Agent = await AgentApi.GetAgent();
      console.log("Agent", Agent);
      if (Agent?.length != 0) {
        setStatusOption(Agent);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // ;
    console.log("templatedata", templateData);
    // console.log("templatedata", templateData);
    if (typeof templateData == "object") {
      const columnsdata = templateData.templateSettingReportConfigList;
      const AgentMaster = columnsdata.find(
        (item) =>
          item.columnSelectBoxWithSaveBtn == "45" &&
          item.columnName == "StatusName"
      );
      const StatusMaster = columnsdata.find(
        (item) =>
          (item.columnSelectBoxWithSaveBtn == "89" &&
            item.columnName == "StatusName") ||
          item.columnName == "statusname"
      );

      if (StatusMaster) {
        fetchStatusMaster();
      }

      if (AgentMaster) {
        fetchAgentMaster();
      }
    }
  }, [templateData]);


  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const data = await CompanyApi.GetCompany();
        // console.log("data", data);

        // console.log(
        //   "UserDetails.firmToAllowAccess",
        //   UserDetails.firmToAllowAccess
        // );
        // temp1.filter(x => a.includes(String(x.id)));
        if (UserDetails) {
          const filteredData = data.filter((x) =>
            UserDetails?.firmToAllowAccess.includes(String(x.id))
          );

          if (filteredData != null) {
            setCompanyList(filteredData);
          } else {
            setCompanyList(data);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData1();
  }, [UserDetails]);

  useEffect(() => {
    console.log(`data`, data);
    console.log(`columns`, columns);
    if (columns) {
      const tempdata = columns
        .map((item, index) => item.Header)
        .filter((item) => {
          if (typeof item !== "string") return false;
          return (
            item.includes("date") ||
            item.includes("Date") ||
            item.toLowerCase() === "createdon"
          );
        });

      if(tempdata.length > 0){
        setDateFilterCustom(tempdata[0]);
      }
      setCutomDateFilter(tempdata);
    }
  }, [data, columns]);

  useEffect(() => {
    console.log("transactionType", transactionType);
  }, [transactionType]);
  /***************************************************************/

  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  /***************************************************************/
  const containerRef2 = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);

  useEffect(() => {
    if (UserDetails && UserDetails.id) {
      const tempSelectedOptions2 = [...selectedOptions2, UserDetails.branchId];
      setSelectedOptions2(tempSelectedOptions2);
    }
  }, [UserDetails]);

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  // const handleCheckboxChange2 = (checkboxValue) => {
  //   // ;
  //   if (selectedOptions2.includes(checkboxValue)) {
  //     setSelectedOptions2(
  //       selectedOptions2.filter((item) => item !== checkboxValue)
  //     );
  //   } else {
  //     setSelectedOptions2([...selectedOptions2, checkboxValue]);
  //   }
  // };

  useEffect(() => {
    const fetchAllList = async () => {
      // setLoading(true);
      try {
        var VariabletoSend = 12;
        if (TransactionTypeSetting && TransactionTypeSetting.length > 0) {
          if (TransactionTypeSetting.transAccount == 216) {
            VariabletoSend = 12;
          } else if (TransactionTypeSetting.transAccount == 215) {
            VariabletoSend = 14;
          } else {
            alert("Please check the transaction type setting.");
          }
        } else {
          var filterdata = [
            {
              fieldName: "transType",
              operatorName: "equal",
              compareValue: id || 12,
            },
          ];

          var data =
            await TransactionTypeSettingAPI.getTransactionTypeSettingFilter(
              filterdata
            );
          if (data && data.length > 0) {
            setTransactionTypeSetting(data[0]);
          }
          if (data[0].transAccount == 216) {
            VariabletoSend = 12;
          } else if (data[0].transAccount == 215) {
            VariabletoSend = 14;
          } else {
            alert("Please check the transaction type setting.");
          }
        }
      } catch (error) {
        console.error("Failed to fetch transaction type settings:", error);
        alert("Failed to fetch transaction type settings.");
      } finally {
        // setLoading(false);
      }
    };

    fetchAllList();
  }, []);

  const handleCheckboxChange2 = (checkboxValue) => {
    //multi firm select
    let updatedOptions = [...selectedOptions2];

    if (updatedOptions.includes(checkboxValue)) {
      updatedOptions = updatedOptions.filter((item) => item !== checkboxValue);
    } else {
      if (!updatedOptions.includes(checkboxValue)) {
        updatedOptions.push(checkboxValue);

        if (checkboxValue !== 0 && updatedOptions.includes(0)) {
          updatedOptions = updatedOptions.filter((item) => item !== 0);
        }
      }
    }
    setSelectedOptions2(updatedOptions);
  };

  const handleCustomDateTypeChange = (e) => {
    // ;
    const { value } = e.target;
    setDateFilterCustom(value);
  };

  const handleSelectAllChange2 = (companyList) => {
    //console.log(companyList);
    if (selectedOptions2?.length !== companyList.length) {
      const allOptions2 = companyList.map((item) => item.id); // Corrected typo in checkBox5
      setSelectedOptions2(allOptions2);
    } else {
      setSelectedOptions2([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef2.current &&
        !containerRef2.current.contains(event.target)
      ) {
        setIsOpen2(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef2]);

  const handleclear = () => {
    
    
    let tempCommonFilter = [...commonFilter];

    tempCommonFilter = tempCommonFilter.filter(item => item.operatorName != "between");

    setCommonFilter(tempCommonFilter);

    setDateRangeToShow({ dateFrom: "", dateTo: "", nameOfDateFilterWhichSet: "" });

    if (reportAttachTo == 63) {

      handleResetQueryDate();
    } else {
      fetchData({
        rowWiseEdit1, rowWiseDelete1, rowWiseWhatsapp1,
        rowWisePrint1, queryData, combinedTotalValue, ef1, ef2,
        reportType, tempCommonFilter
      });
    }

    setCustomStartDate("");
    setCustomEndDate("");

  };

  const [increasecount, setincreasecount] = useState(0);
  const [currentpagecount, setcurrentpagecount] = useState(1);
  const handlenext = () => {
    // ;
    //console.log("logext");
    setPageNumber(PageNumber + 1);
    setcurrentpagecount((prev) => prev + 1);
    setincreasecount((prev) => prev + pagecount);
  };

  const handleprev = () => {
    PageNumber != 1 && setincreasecount((prev) => prev - pagecount);
    PageNumber != 1 && setPageNumber(PageNumber - 1);
    currentpagecount != 1 && setcurrentpagecount((prev) => prev - 1);
  };

  function handlePageNumKeyDown(e) {
    let value = Number(pageNumInputRef.current.value);
    if (
      e.key == "Enter" &&
      pageNumInputRef.current.value <= Math.ceil(totalRecords / pagecount)
    ) {
      setPageNumber(value);
      setcurrentpagecount(value);
      setincreasecount((value - 1) * pagecount);
    }
  }

  useEffect(() => {
    pageNumInputRef.current.value = currentpagecount;
  }, [currentpagecount]);

  const hanldeclose = () => {
    setisDropdownOpen1("");
    setsuggetion([]);
  };
  
    const navigate = useNavigate();

  const handlesavebtnforsingle = async (e, item) => {
    console.log(e.target.value);

    const statusid = getCaseInSensitiveFieldValueFromObject("statusid", item.original);
    const billstatusid = getCaseInSensitiveFieldValueFromObject("billstatusid", item.original);
    const id = getCaseInSensitiveFieldValueFromObject("id", item.original);
    const mobileno = getCaseInSensitiveFieldValueFromObject("mobileno", item.original);
    const email = getCaseInSensitiveFieldValueFromObject("email", item.original);

    // ;
    const missingFields = [];
    // if (!item.original.mobileno) missingFields.push("Mobile No");
    if (!statusid && !billstatusid)
      missingFields.push("Status ID");
    if (!id) missingFields.push("ID");
    // if (!item.original.email) missingFields.push("Email");

    if (missingFields.length > 0) {
      alert(`Please check the following fields: ${missingFields.join(", ")}`);
      return;
    }
    if (mobileno) {
      setMobileNo(mobileno);
    } else {
      setMobileNo(0);
    }

    setSelectedStatusId1(
      selectedstatus.id ? selectedstatus.id : statusid || 0
    );

    if (id) {
      setTransactonId(id);
    } else {
      setTransactonId(0);
    }
    if (email) {
      setEmail(email);
    } else {
      setEmail("");
    }

    try {
      // ;
      const masterType = reportAttachTo;
      const Tranid = id;
      const statusId = selectedstatus.id;
      if (masterType && Tranid && statusId) {
        const requst = await AddVoucher.UpdateVouchStatusByid(
          masterType,
          Tranid,
          statusId
        );
        if (requst.isSuccess) {
          ;
          const storedArrayString = localStorage.getItem(
            "loginAccountUserData"
          );
          const loginUser = JSON.parse(storedArrayString);

          const extractIdFromSaleUsedIn = (input) => {
            if (!input || !input.includes(":")) return 0;

            const parts = input.split(":");
            const id = parts[1]?.trim();

            return isNaN(id) ? 0 : parseInt(id, 10);
          };

          //const ord2IdValue = isSaleOrderToInvoice ? item.original.id : (item.original.ord2Id || 0);

          const saleusedin = getCaseInSensitiveFieldValueFromObject("saleusedin", item.original);
          const saleusedinid = getCaseInSensitiveFieldValueFromObject("saleusedinid", item.original);
          const masttype = getCaseInSensitiveFieldValueFromObject("masttype", item.original);

          var ord2IdValue = 0;
          if (saleusedin) {
            ord2IdValue =
              masttype == 12 ? saleusedinid : 0;
          } else {
            ord2IdValue = 0;
          }

          const ord1Id = getCaseInSensitiveFieldValueFromObject("ord1Id", item.original);

          const insertData = {
            ord1Id: ord1Id || Tranid,
            ord2Id: ord2IdValue,
            statusId: statusId,
            orderDateTime: new Date().toISOString(),
            createdBy: loginUser.userId,
            isActive: true,
          };

          const insertResult = await Order.insertItemStatusInventory(
            insertData
          );

          // setOpenMessageModal(true);
          if (insertResult) {
            setOpenMessageModal(true);
          } else {
            alert("insertItemStatus failed!");
          }
        }
      }
    } catch (error) {
      console.log(error);
      alert(`Status Update Failed!`);
    }
  };
  const handleDoubleClick = (row) => {
    // ;
    if (disableDoubleClick) {
      return;
    }

    let url;
    const checkmastertype = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    if (!checkmastertype.includes(parseInt(navigateTo))) {
      url = `/MasterListReportFormat2?${navigateTo}`;
    } else {
      url = `/MasterListReport?${navigateTo}`;
    }
    changeDoubleClickFilter(row, url);
    // navigate(url)
    // setReportAttachTo(navigateTo)
    console.log("row");
    // console.log("row", row.t2id);
    // handleNavigation1(row.id, ReportType, ToTransType);
    // const conditions = {
    //   1: () => alert("one"),
    //   2: () => alert("two"),
    //   //ReportType 4
    //   63: () => handleNavigation(navigateTo, row),
    // };

    // if (conditions[reportAttachTo]) {
    //   conditions[reportAttachTo]();
    // } else {
    //   console.warn("No function found for this ID");
    // }
  };

  const handleMouseEnterDisable = () => {
    // // ;
    if (setDisableDoubleclick) {
      setDisableDoubleclick(true);
    }
  };

  const handleMouseLeaveEnable = () => {
    // // ;
    if (setDisableDoubleclick) {
      setDisableDoubleclick(false);
    }
  };

  const handleStatusChangefnc = async (e, cell, row) => {
    try {
      // ;
      console.log(`page`, page);
      console.log(`page`, row);
      const { value } = e.target;
      const id = document.getElementById(`${cell.row.id}_${cell.value}`);
      id.value = value;

      const fieldNameInObj = getOriginalObjFieldBasedOnAnyCase("statusname", page[row.id].original);

      page[row.id].original[fieldNameInObj] = value;
      // data?.statusname=value
      const findstatus = StatusOption.find((item) => item.name == value);
      if (findstatus) {
        setselectedstatus(findstatus);
      }

      const Id = getCaseInSensitiveFieldValueFromObject("id", row.original);

      const StatusData = {
        id: Id,
        statusid: findstatus.id,
      };
      setstatusvalue((prev) => [...prev, StatusData]);
      setSelectedStatusId1(findstatus.id);
    } catch (error) {
      console.log(error);
    }
  };

  const alphabeticList = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  const handleOnclick = async (e, index, column) => {
    setHighlightedIndex(index);
    const find = suggeitem[index];
    const id = document.getElementById(column.Header.props.name);
    console.log(find);
    if (find) {
      const data = {
        target: {
          name: column.Header.props.name,
          value: id.value.length > 0 ? find.item.name : "",
        },
      };
      debouncedFunction(data);
    }
  };

  function handleAlphabetClick(alphabet) {
    handleAlphabetSelect(alphabet);
    setActiveAlphabet((prev) => (prev === alphabet ? null : alphabet)); // toggle
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        filterDateDivRef.current &&
        !filterDateDivRef.current.contains(event.target)
      ) {
        setShowbox(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = async (e, id, row) => {
    const perrow = document.getElementById(`row-${id}`);
    perrow.style.height = "auto";

    console.log(`row`, row);
    if (row) {
      row.cells.map((singlecell, rowIndex) => {
        const cellid = document.getElementById(`cell-${id}-${rowIndex}`);
        if (cellid) {
          cellid.style.whiteSpace = "normal";
          cellid.style.transitionProperty = "all";
          cellid.style.transition = "500ms";
        }
      });
    }
  };

  const handleMouseLeave = async (e, id, row) => {
    const perrow = document.getElementById(`row-${id}`);
    perrow.style.height = "25px";
    if (row) {
      row.cells.map((singlecell, rowIndex) => {
        const cellid = document.getElementById(`cell-${id}-${rowIndex}`);
        if (cellid) {
          cellid.style.whiteSpace = "nowrap";
          cellid.style.transitionProperty = "all";
          cellid.style.transition = "200ms";
        }
      });
    }
  };

  useEffect(() => {
    // const find = suggeitem[highlightedIndex];
    // const column = filterData.find(
    //   (item) => item?.Header?.props?.name == isDropdownOpen1?.props?.name
    // );
    // if (column && find) {
    //   const id = document.getElementById(column.Header.props.name);
    //   id.value = find.item.name;
    // }
  }, [highlightedIndex]);

  const handleKeyDown_AccountSuggestion = (e, ToFilterData, column) => {
    if (!ToFilterData.length) return;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightedIndex(
          (prevIndex) => (prevIndex + 1) % ToFilterData.length
        );

        break;
      case "ArrowUp":
        e.preventDefault();
        setHighlightedIndex((prevIndex) =>
          prevIndex === 0 ? ToFilterData.length - 1 : prevIndex - 1
        );
        break;
      case "Enter":
        e.preventDefault();
        if (highlightedIndex >= 0 && highlightedIndex < ToFilterData.length) {
          const find = suggeitem[highlightedIndex];
          const id = document.getElementById(column.Header.props.name);
          id.value = find.item.name;
          setisDropdownOpen1("");
          setsuggetion([]);
          console.log(find);
          if (find) {
            const data = {
              target: {
                name: column.Header.props.name,
                value: id.value.length > 0 ? find.item.name : "",
              },
            };
            debouncedFunction(data);
          }
          console.log(`call api`);
        }
        break;
      case "Escape":
        setsuggetion([]);
        break;
      default:
        break;
    }
  };

  const handlefocus = async (data, value = "") => {
    if (data) {
      console.log(data);
      setisDropdownOpen1(data?.Header);
      const findcolumn = templateData.templateSettingReportConfigList.find(
        (item) => item.columnName == data.Header.props.name
      );
      console.log(findcolumn);
      let temp;
      let suggeitem;
      if (findcolumn.columnSelectBoxWithSaveBtn.length == 0) {
        return;
      }
      temp = {
        MasterType: findcolumn.columnSelectBoxWithSaveBtn,
        GroupWiseSuggestion: false,
        IsAttributeParent: true,
        GroupId: "",
        search_str: value,
        PageNumber: 1,
        PageSize: 15,
        IsEcomStore: false,
      };

      suggeitem = await Account.GetAccountListForAutoSuggestion(temp);
      console.log(suggeitem);
      if (suggeitem) {
        let temparray = [];
        suggeitem?.map((item, index) => {
          temparray.push({
            item: item,
            seleccted: false,
          });
        });
        setsuggetion(temparray);
      }
    }
  };

  useEffect(() => {
    console.log(suggeitem);
  }, [suggeitem]);

  return (
    <div className="panel panel-default">
      <div className="panel-body">
        {/* ... Search panel code ... */}
        <div
          className="col-sm-12"
          id="pdfContent"
          style={
            showNav !== undefined && showNav === false
              ? { width: "100%", padding: "0" }
              : { width: "94vw", padding: "0" }
          }
        >
          {/* <button onClick={handleExportToExcel}>Btn</button> */}
          <div className="Search-Any_Text" style={{ marginTop: "5px" }}>
            {/* <div className="searchReportBox"> */}
            {DropdownData.length > 0 && (
              // <div className="Search-report-box" style={{ width: "20%" }}>
              //   <select
              //     onChange={(e) => changetablevalue(e)}
              //     value={currentPageId}
              //   >
              //     {DropdownData.map((item) => (
              //       <option key={item.id} value={item.id}>
              //         {item.MasterName}
              //       </option>
              //     ))}
              //   </select>
              // </div>

              <div className="CompWidthMasterUser FirmName-select">
                <div className="input-box-mok1">
                  <select
                    className="modify_im_input mode_category1 input-firmname"
                    onChange={(e) => changetablevalue(e)}
                    value={currentPageId}
                  >
                    {DropdownData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.MasterName}
                      </option>
                    ))}
                  </select>
                  <label className="UseMasterLebalFix">Transaction Type</label>
                </div>
              </div>
            )}
            {searchAnyText == true && (
              <div className="Search-report-box">
                <input
                  className="Input-search-report"
                  type="text"
                  // value={universalSearch}
                  // onChange={(e) => setUniversalSearch(e.target.value)}
                  onKeyDown={(e) =>
                    handleKeyDownUniversal(e, filterData, e.target.value)
                  }
                  onChange={(e) => {

                    if (handleNameChange !== undefined){
                        handleNameChange(e);
                    }
                  }}
                  placeholder="Search By Any Text"
                  value={nameSearch}
                />
              </div>
            )}
            {/* </div> */}

            {firmNameSelect == true && (
             <div style={{zIndex: 4}}
                className="CompWidthMasterUser FirmName-select"
                ref={containerRef2}
              >
                <div className="input-box-mok1" onClick={toggleDropdown2}>
                  <select
                    className="modify_im_input mode_category1 input-firmname"
                    type="checkbox"
                    required
                  >
                    <option>Select options</option>
                    {/* {companyList && companyList.length > 0 ? (
                                                companyList.map((company, index) => (
                                                    <option
                                                        className="s-1 form-control"
                                                        value={company.branchCode}
                                                        key={index}
                                                    >
                                                        {company.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option>No options available</option>
                                            )} */}
                  </select>
                  <label className="UseMasterLebalFix">Firm Name</label>
                  <div className="overSelect"></div>
                </div>
                {isOpen2 && (
                  <div
                    className="check-firname"
                    id="checkBoxes"
                    style={{ zIndex: 3 }}
                  >
                    <label htmlFor="selectAll">
                      <input
                        className="user_checkbox"
                        type="checkbox"
                        id="selectAll"
                        checked={
                          selectedOptions2?.length === companyList?.length
                        }
                        onChange={() => handleSelectAllChange2(companyList)}
                      />
                      Select All
                    </label>
                    {companyList?.map((company) => (
                      <label htmlFor="first" key={company.id}>
                        <input
                          className="user_checkbox"
                          type="checkbox"
                          id={company.id}
                          checked={selectedOptions2?.includes(company.id)}
                          onChange={() => handleCheckboxChange2(company.id)}
                        />
                        {company.name}
                      </label>
                    ))}
                    {/* <label htmlFor="second">
                                                <input className="user_checkbox"
                                                    type="checkbox" id="second"
                                                    checked={selectedOptions2.includes('checkBox2')}
                                                    onChange={() => handleCheckboxChange2('checkBox2')} />
                                                My Optical
                                            </label>

                                            <label htmlFor="third">
                                                <input className="user_checkbox"
                                                    type="checkbox" id="third"
                                                    checked={selectedOptions2.includes('checkBox3')}
                                                    onChange={() => handleCheckboxChange2('checkBox3')} />
                                                E-Com
                                            </label>

                                            <label htmlFor="fourth">
                                                <input className="user_checkbox"
                                                    type="checkbox" id="fourth"
                                                    checked={selectedOptions2.includes('checkBox4')}
                                                    onChange={() => handleCheckboxChange2('checkBox4')} />
                                                Restaurant
                                            </label>
                                            <label htmlFor="fourth">
                                                <input className="user_checkbox"
                                                    type="checkbox" id="fourth"
                                                    checked={selectedOptions2.includes('checkBox5')}
                                                    onChange={() => handleCheckboxChange2('checkBox5')} />
                                                Pharmacy
                                            </label> */}
                  </div>
                )}
              </div>
            )}
            {transactionType == true && (
              <div className="CompWidthMasterUser FirmName-select">
                <div className="input-box-mok1">
                  <select
                    className="modify_im_input mode_category1 input-firmname"
                    type="checkbox"
                    required
                  >
                    <option>Extra Option</option>
                    {/* <option>Purchase</option>
                    <option>Sale Return</option>
                    <option>Purchase</option> */}
                  </select>
                  <label className="UseMasterLebalFix">Extra Field</label>
                </div>
              </div>
            )}
            {billSeries == true && (
              <div className="CompWidthMasterUser FirmName-select">
                <div className="input-box-mok1">
                  <select
                    className="modify_im_input mode_category1 input-firmname"
                    type="checkbox"
                    required
                  >
                    <option>All</option>
                    <option>Sale</option>
                    <option>Sale-L</option>
                  </select>
                  <label className="UseMasterLebalFix">Bill Series</label>
                </div>
              </div>
            )}
            {searchByDate == true && (
              <div ref={filterDateDivRef} className="tablelist-datefilter-box">

                <div>

                  <button
                    className="tablelist-main-search-button"
                    onClick={showdatefilter}
                  >


                    Select Date
                    {/* {dateRangeToShow.nameOfDateFilterWhichSet ? `${dateRangeToShow.dateFrom} to ${dateRangeToShow.dateTo}` : "Select Date Filter"}  */}


                  </button>


                </div>
                  {dateRangeToShow.nameOfDateFilterWhichSet && <div className="master-report-data-table-select-from-to-date-div">
                    <span>{formatDate(dateRangeToShow.dateFrom)} to {formatDate(dateRangeToShow.dateTo)}</span>
                    </div> }

                {showbox && (
                  <div className="tablelist-datefilter date-right-prev">
                    <div className={`date-type-select`}>
                      <span>Date Type</span>
                      <select
                        onChange={(e) => handleCustomDateTypeChange(e)}
                        name=""
                        id=""
                        className={`custom-date-filter`}
                      >
                        {/* <option value="">-select-</option> */}
                        {CustomDateFilter.map((item, index) => {
                          console.log(`item`, item);
                          return <option value={item}>{item}</option>;
                        })}
                      </select>
                    </div>
                    <div className="tablelist-datefilter-1">
                      {[
                        "Today",
                        "Yesterday",
                        "This Week",
                        "Last 7 Days",
                        "This Month",
                        "Previous Month",
                      ].map((filter) => (
                        <div
                          key={filter}
                          className={`tablelist-datefilter-option ${
                          dateRangeToShow.nameOfDateFilterWhichSet == filter ? "tablelist-datefilter-option-selected"
                            : ""
                            }`}
                          onClick={handleCustomDateChange}
                        >
                          {filter}
                        </div>
                      ))}
                    </div>
                    <div className="tablelist-datefilter-2">
                      <p style={{ margin: "0", textAlign: "start" }}>Custom</p>
                      <div className="tablelist-datefilter-date">
                        <input
                          type="date"
                          name=""
                          id="start-date"
                          value={customStartDate}
                          onChange={handleCustomDateChange}
                          className={dateRangeToShow.nameOfDateFilterWhichSet == "Custom Date" ? "tablelist-datefilter-option-selected" : ""}
                        />{" "}
                        to
                        <input
                          type="date"
                          name=""
                          id="end-date"
                          value={customEndDate}
                          onChange={handleCustomDateChange}
                          className={dateRangeToShow.nameOfDateFilterWhichSet == "Custom Date" ? "tablelist-datefilter-option-selected" : ""}

                        />
                      </div>
                    </div>
                    <button
                      className="tablelist-datefilter-button"
                      //  onClick={showdatefilter}
                      onClick={(e) => handleCustomDateChange(e, filterData)}
                    >
                      Apply
                    </button>
                    {true && (
                      <button
                        className="tablelist-datefilter-button"
                        onClick={() => handleclear()}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          <div
            style={
              showNav === undefined && showNav !== false
                ? { width: "100%", overflow: "auto" }
                : { width: "100%", overflow: "auto" }
            }
          >
            <div
              style={{
                // minWidth: "max-content",
                minHeight: "",
                maxHeight: "72vh",
                overflow: "auto",
                // scrollbarWidth: "none",
              }}
            >
              <table
                className="tableList-main"
                {...getTableProps()}
                style={{ overflowX: "auto" }}
              >
                {/* <thead className="tablelist-input-box" style={{ height: "35px" }}>
                                <tr>

                                    <th></th>
                                </tr>
                            </thead> */}
                {/* <div style={{ position: 'sticky', top: '0', display: 'block', width:'100vw' }}> */}
                {searchByColumn == true && (
                  <thead
                    className="tablelist-input-box thead-2"
                    style={{
                      height: "35px",
                      position: "sticky",
                      top: "-1px",
                      zIndex: "3",
                    }}
                  >
                    <tr>
                      {filterData.map((data, index) => {
                        console.log(data.Header.props);

                        return (
                          <th
                            // colSpan={index === 0 ? 2 : 1}
                            key={index}
                            // style={{ width: "max-content" }}
                          >
                            <div
                              style={{ position: "relative" }}
                              className={`header-div`}
                            >
                              <span
                                onKeyUp={(e) =>
                                  handleKeyDown_AccountSuggestion(
                                    e,
                                    suggeitem,
                                    data
                                  )
                                }
                                onChange={debounce(
                                  async (e) =>
                                    handlefocus(data, e.target.value),
                                  500
                                )}
                                onClick={(e) => handlefocus(data)}
                              >
                                {data.Header}
                              </span>
                              {isDropdownOpen1 == data.Header && (
                                <>
                                  <ul
                                    className="ItemmasterDuggestionsaleinvoice ul-div-ItemmasterDuggestionsaleinvoice"
                                    // ref={suggestionBoxRef}
                                  >
                                    {suggeitem.map((Acc, index) => (
                                      <li
                                        key={Acc.item.id}
                                        onClick={(e) =>
                                          handleOnclick(e, index, data)
                                        }
                                        style={{
                                          padding: "5px 5px",
                                          cursor: "pointer",
                                          borderBottom: "1px solid #ccc",
                                          backgroundColor:
                                            highlightedIndex === index
                                              ? "#e6f7ff"
                                              : "transparent",
                                        }}
                                      >
                                        {Acc?.item.name}
                                      </li>
                                    ))}
                                  </ul>
                                  <div
                                    style={{
                                      display:
                                        isDropdownOpen1.length == 0
                                          ? "none"
                                          : "block",
                                    }}
                                    onClick={() => hanldeclose()}
                                    className={`close-div-masterdata-tabel`}
                                  ></div>
                                </>
                              )}
                            </div>
                          </th>
                        );
                      })}
                      <th
                        style={{
                          position: "sticky",
                          right: "0",
                          background: "#f8f9fa",
                        }}
                      ></th>
                    </tr>
                  </thead>
                )}

                <thead
                  id="pdfContent"
                  className="table-head-main"
                  style={
                    searchByColumn == true
                      ? {
                          height: "35px",
                          position: "sticky",
                          top: "33px",
                          zIndex: "1",
                        }
                      : {
                          height: "35px",
                          position: "sticky",
                          top: "0px",
                          zIndex: "1",
                        }
                  }
                >
                  {headerGroups.map((headerGroup, index) => {
                    return (
                      <tr
                        // onMouseEnter={(e) => handleColorChange(e)}
                        className={`masterlist-color-change`}
                        {...headerGroup.getHeaderGroupProps()}
                        id={`header-row-${index}`}
                      >
                        {headerGroup.headers
                          .filter((column, columnIndex) => {
                            if (column.id == "input" && disablecheckbox) {
                              return false;
                            }
                            if (disableaction && String(column.Header)?.toLowerCase() == "ACTION".toLowerCase()) {
                              return false;
                            }
                            if (showNav === false) {
                              if (String(column.Header)?.toLowerCase() == "ACTION".toLowerCase()) {
                                return false;
                              } else {
                                return true;
                              }
                            }

                            return true;
                          })
                          .map((column, columnIndex) => {
                            if (String(column.Header)?.toLowerCase() == "StatusName".toLowerCase()) {
                              return (
                                <th>
                                  {StatusOption && StatusOption.length > 0 ? (
                                    <div>
                                      {column.render("Header")}
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => handleSubmitForall(e)}
                                        className={`save-btn`}
                                      >
                                        <i class="fas fa-save"></i>
                                      </span>
                                    </div>
                                  ) : (
                                    <div>{column.render("Header")}</div>
                                  )}
                                </th>
                              );
                            }

                            if (String(column.Header.toLowerCase)?.toLowerCase() == "SNO".toLowerCase()) {
                              return (
                                <th
                                  // style={{ width: "40px" }}
                                  {...column.getHeaderProps()}
                                  id={`header-${index}-${columnIndex}`}
                                >
                                  {column.render("Header")}
                                </th>
                              );
                            }

                            if (String(column.Header)?.toLowerCase() == "ACTION".toLowerCase()) {
                              return (
                                <th
                                  style={{
                                    position: "sticky",
                                    right: "0",
                                    backgroundColor: "#212E4F",
                                    transform: "translateY(0px)",
                                  }}
                                  {...column.getHeaderProps()}
                                  id={`header-${index}-${columnIndex}`}
                                >
                                  {column.render("Header")}
                                </th>
                              );
                            }

                            return (
                              <th
                                {...column.getHeaderProps()}
                                id={`header-${index}-${columnIndex}`}
                              >
                                {column.render("Header")}
                              </th>
                            );
                          })}
                      </tr>
                    );
                  })}
                </thead>

                {/* </div> */}

                <tbody
                  id=""
                  style={{ height: "auto", overflowY: "auto" }}
                  className="table-body-main"
                  {...getTableBodyProps()}
                >
                  {page.map((row, rowIndex) => {
                    // console.log("page", page);
                    prepareRow(row);

                    // // ;
                    const CompanyName = getCaseInSensitiveFieldValueFromObject("companyname", row.original);
                    const prevCompanyName = rowIndex > 0 ? getCaseInSensitiveFieldValueFromObject("companyname", page[rowIndex - 1].original) : null;
                    const currentCompanyName = CompanyName;
                    const previousCompanyName = prevCompanyName

                    // const insertSeparator =
                    //   selectedOptions2.length > 1 &&
                    //   currentCompanyName !== previousCompanyName;
                    const insertSeparator =
                      selectedOptions2.length >= 2 &&
                      (rowIndex === 0 ||
                        currentCompanyName !== previousCompanyName);
                    // console.log(
                    //   "selectedOptions2.length",
                    //   selectedOptions2.length
                    // );

                    const isecominvoice = getCaseInSensitiveFieldValueFromObject("isecominvoice", row.original);

                    return (
                      <React.Fragment key={rowIndex}>
                        {insertSeparator && (
                          <tr className="separator-row">
                            <td
                              colSpan={row.cells.length}
                              style={{
                                backgroundColor: "#e8f4ff",
                                height: "25px",
                                textAlign: "center",
                                fontWeight: "bold",
                                // paddingLeft: "10px",
                                borderTop: "2px solidrgb(106, 180, 255)",
                              }}
                            >
                              Company: {currentCompanyName}
                            </td>
                          </tr>
                        )}
                        <tr
                          {...row.getRowProps()}
                          // style={{}}3
                          onMouseEnter={(e) =>
                            handleMouseEnter(e, rowIndex, row)
                          }
                          onMouseLeave={(e) =>
                            handleMouseLeave(e, rowIndex, row)
                          }
                          style={{
                            overflow: "hidden",
                            height: "25px",
                            backgroundColor:
                              isecominvoice != null
                                ? String(
                                    isecominvoice
                                  ).toLowerCase() === "true"
                                  ? "rgb(255 244 244)"
                                  : "white"
                                : "white",
                          }}
                          id={`row-${rowIndex}`}
                          className={useDoubleClick ? "highlight-row" : ""}
                          onDoubleClick={
                            useDoubleClick
                              ? () => handleDoubleClick(row)
                              : undefined
                          }
                        >
                          {row.cells
                            .filter((cell, cellIndex) => {
                              if (
                                cell.column.id == "input" &&
                                disablecheckbox
                              ) {
                                return false;
                              }

                              if (
                                disableaction &&
                                String(cell.column.Header)?.toLowerCase() == "ACTION".toLowerCase()
                              ) {
                                return false;
                              }
                              if (showNav === false) {
                                if (String(cell.column.Header)?.toLowerCase() == "ACTION".toLowerCase()) {
                                  return false;
                                } else {
                                  return true;
                                }
                              }

                              return true;
                            })
                            .map((cell, cellIndex) => {
                              if (String(cell.column.Header)?.toLowerCase() == "REPORT TYPE".toLowerCase()) {
                                if (cell.value == 1) {
                                  return (
                                    <td
                                      style={{
                                        minWidth: "80px",
                                        overflow: "hidden",
                                      }}
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                    >
                                      List Type
                                    </td>
                                  );
                                }
                              }
                              if (String(cell.column.Header)?.toLowerCase() == "REPORT TYPE".toLowerCase()) {
                                if (cell.value == 2) {
                                  return (
                                    <td
                                      style={{
                                        minWidth: "80px",
                                        overflow: "hidden",
                                      }}
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                    >
                                      Bill Type
                                    </td>
                                  );
                                }
                              }
                              if (String(cell.column.Header)?.toLowerCase() == "REPORT TYPE".toLowerCase()) {
                                if (cell.value == 3) {
                                  return (
                                    <td
                                      style={{
                                        minWidth: "80px",
                                        overflow: "hidden",
                                      }}
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                    >
                                      Import Export Type
                                    </td>
                                  );
                                }
                              }
                              if (
                                String(cell?.column.Header)?.toLowerCase() == "StatusName".toLowerCase()
                              ) {

                                const statusname = getCaseInSensitiveFieldValueFromObject("statusname", cell.row.original);
                                return (
                                  <td
                                    style={{
                                      minWidth: "80px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {StatusOption && StatusOption.length > 0 ? (
                                      <div className={`div-for-box-status`}>
                                        <select
                                          className={`select-box-status`}
                                          onMouseLeave={(e) =>
                                            handleMouseLeaveEnable(e)
                                          }
                                          onMouseEnter={(e) =>
                                            handleMouseEnterDisable(e)
                                          }
                                          id={`${cell.row.id}_${cell.value}`}
                                          value={statusname}
                                          onChange={(e) =>
                                            handleStatusChangefnc(e, cell, row)
                                          }
                                        >
                                          {StatusOption.map((item, index) => {
                                            return (
                                              <option value={item?.name}>
                                                {item?.name}
                                              </option>
                                            );
                                          })}
                                        </select>
                                        <span
                                          onClick={(e) =>
                                            handlesavebtnforsingle(e, row)
                                          }
                                          className={`save-btn`}
                                        >
                                          <i class="fas fa-save"></i>
                                        </span>
                                      </div>
                                    ) : (
                                      <div>{cell.value}</div>
                                    )}
                                  </td>
                                );
                              }

                              if (cell.column.id == "input") {
                                return (
                                  <td
                                    style={{
                                      minWidth: "80px",
                                      overflow: "hidden",
                                    }}
                                    {...cell.getCellProps()}
                                    id={`cell-${rowIndex}-${cellIndex}`}
                                  >
                                    <div
                                      onMouseLeave={(e) =>
                                        handleMouseLeaveEnable(e)
                                      }
                                      onMouseEnter={(e) =>
                                        handleMouseEnterDisable(e)
                                      }
                                      onChange={(e) =>
                                        handleinputchange(e, row)
                                      }
                                    >
                                      {cell.render("Cell")}
                                    </div>
                                  </td>
                                );
                              }
                              if (String(cell.column.Header)?.toLowerCase() == "REPORT TYPE".toLowerCase()) {
                                if (cell.value == 4) {
                                  return (
                                    <td
                                      style={{
                                        minWidth: "80px",
                                        overflow: "hidden",
                                      }}
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                    >
                                      Ledger Detail List Type
                                    </td>
                                  );
                                }
                              }

                              if (String(cell.column.Header)?.toLowerCase() == "SNO".toLowerCase()) {
                                //console.log("sno cell", cell);

                                return (
                                  <React.Fragment key={cellIndex}>
                                    <td
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                      style={{
                                        minWidth: "40px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {/* {cell.value + increasecount} */}
                                      {cell.render("Cell")}
                                    </td>
                                  </React.Fragment>
                                );
                              }

                              if (
                                String(cell.column.Header)?.toLowerCase() ==
                                "billamt"
                              ) {
                                return (
                                  <React.Fragment key={cellIndex}>
                                    <td
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                      // style={{ width: "40px" }}
                                    >
                                      {Math.floor(cell.value)}
                                    </td>
                                  </React.Fragment>
                                );
                              }

                              if (
                                String(cell.column.Header)?.toLowerCase() == "dueamt"
                              ) {
                                return (
                                  <React.Fragment key={cellIndex}>
                                    <td
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                      // style={{ width: "40px" }}
                                    >
                                      {cell.value.toFixed(decimalPlaces)}
                                      {/* {Math.floor(cell.value)} */}
                                    </td>
                                  </React.Fragment>
                                );
                              }

                              if (String(cell.column.Header)?.toLowerCase() == "ACTION".toLowerCase()) {
                                return (
                                  <React.Fragment key={cellIndex}>
                                    <td
                                      style={{
                                        position: "sticky",
                                        right: "0",
                                        padding: "0",
                                        overflow: "hidden",
                                        backgroundColor:
                                          row.original.isecominvoice != null
                                            ? String(
                                                row.original.isecominvoice
                                              )?.toLowerCase() === "true"
                                              ? "rgb(255 244 244)"
                                              : "white"
                                            : "white",
                                        border: "1px solid #dddddd",
                                        transform: "translateY(0px)",
                                      }}
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  </React.Fragment>
                                );
                              }

                              if (
                                dbColumnAndReportColumnNameMap &&
                                String(dbColumnAndReportColumnNameMap[
                                  cell.column.id
                                ])?.toLowerCase() == "AMobileNo".toLocaleLowerCase()
                              ) {
                                return (
                                  <React.Fragment key={cellIndex}>
                                    <td
                                      {...cell.getCellProps()}
                                      id={`cell-${rowIndex}-${cellIndex}`}
                                      // style={{ width: "40px" }}
                                    >
                                      {cell.value &&
                                      UserDetails &&
                                      UserDetails.canLst3DgtNo
                                        ? cell.value.slice(
                                            0,
                                            cell.value.length - 3
                                          ) + "XXX"
                                        : cell.value}
                                    </td>
                                  </React.Fragment>
                                );
                              }

                              // if (dbColumnAndReportColumnNameMap && dbColumnAndReportColumnNameMap[cell.column.id] == "IPurchasePrice".toLocaleLowerCase()) {
                              //   return (
                              //     <React.Fragment key={cellIndex}>
                              //       <td
                              //         {...cell.getCellProps()}
                              //         id={`cell-${rowIndex}-${cellIndex}`}
                              //       // style={{ width: "40px" }}
                              //       >
                              //         {cell.value && ((UserDetails && UserDetails.isShowPrchsePrcForItm)) ? cell.value : "XXX"}
                              //       </td>
                              //     </React.Fragment>
                              //   );
                              // }

                              return (
                                <React.Fragment key={cellIndex}>
                                  <td
                                    style={{
                                      minWidth: "80px",
                                      overflow: "hidden",
                                    }}
                                    {...cell.getCellProps()}
                                    id={`cell-${rowIndex}-${cellIndex}`}
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {/* </div> */}
                </tbody>
              </table>
            </div>
          </div>


<div className="table-list-box-bottom">  

          {totalValue &&
            totalValue.length > 0 &&
            (console.log(totalValue),
            (
              <>
                <div
                  className="table-list-button-box"
                  style={{ flexDirection: "row-reverse" }}
                >
                  <div
                    style={{
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "5px",
                      width: "100%",
                       margin: "3px"
                    }}
                  >
                    {totalValue &&
                      totalValue.map((data, index) => {
                        // //console.log("columns", data);
                        if (data.columnShowTotalValue == "false") {
                          return null;
                        }
                        return (
                          <div
                            style={{
                              display:
                                data.columnShowTotalValue == "true"
                                  ? "block"
                                  : "none",
                              width: "190px",
                              textAlign: "center",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            className="tablelist-input-box"
                            key={index}
                          >
                            <label
                              className=""
                              type="text"
                              key={index}
                              style={{
                                width: "max-content",
                                margin: "2px 3px",
                                padding: "0px 3px",
                              }}
                            >
                              {data.total !== null
                                ? `${data.accessor.toUpperCase()} TOTAL: ${Number(
                                    data.total.toFixed(2)
                                  )}`
                                : ""}
                            </label>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            ))}

          <div className="table-list-button-box relative">
            {/* <div className="shortcutkeys-header">
                                {columns.map((data, index) => {
                                    if (index !== columns.length - 3 && index !== columns.length - 2 && index !== columns.length - 1) {
                                        return (
                                            <p key={index} style={{ fontSize: "13px", color: "#212e4f" }}>
                                                Press ALT + {index + 1} to open {columns[index + 2]?.Header || 'unknown'} filter
                                            </p>
                                        );
                                    }
                                    return null;
                                })}
                            </div> */}

            {showNav === false && (
              <button
                onClick={addOrders}
                className="save-button-main-save master-report-data-table-add-button"
              >
                Add
              </button>
            )}

            <div
              className="shortcutkeys-header"
              style={{
                display: "flex",
                justifyContent: "end",
                margin: "2px 50px",
              }}
            >
              <div className="masterReportDataTable-alphabet-container">
                {alphabeticList.map((alphabet, index) => (
                  <div
                    onClick={() => handleAlphabetClick(alphabet)}
                    key={index}
                    className={`masterReportDataTable-alphabet-container-div ${
                      activeAlphabet === alphabet ? "active" : ""
                    }`}
                  >
                    {alphabet}
                  </div>
                ))}
              </div>

              <div>
                <input
                  className="pagenosearchbtn"
                  ref={pageNumInputRef}
                  type="number"
                  onKeyDown={handlePageNumKeyDown}
                  min={1}
                  max={Math.ceil(totalRecords / pagecount)}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "160px",
                  margin: "5px 0px",
                }}
              >
                <button
                  onClick={() => handleprev()}
                  // disabled={!canPreviousPage}
                  className="table-list-button"
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <span className="table-list-page-txt">
                  Page -
                  <strong style={{ margin: "0px 3px" }}>
                    {/* {pageIndex + 1} of {Math.ceil(data.length / pageSize)} */}
                    {currentpagecount} of {Math.ceil(totalRecords / pagecount)}
                  </strong>
                </span>
                <button
                  onClick={() => handlenext()}
                  disabled={page.length < pagecount}
                  className="table-list-button"
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>

              {showSetting && (
                <a
                  href={`/ReportTemplateSettingList?q=${templateSettingDTOId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    style={{
                      fontSize: "16px",
                      marginTop: "3px",
                      cursor: "pointer",
                      color: "#212E4F",
                    }}
                    class="fa-solid fa-gear"
                  ></i>
                </a>
              )}
            </div>
          </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default MasterReportDataTable;
